// TestAttachment.js

import React, { useState } from "react";
import api from "../api/api";
import Swal from "sweetalert2";

import {
  Modal,
  Form,
  Input,
  Upload,
  Button,
  Typography,
  Space,
  Divider,
  Flex,
} from "antd";

import {
  InboxOutlined,
  CloudUploadOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;
const { TextArea } = Input;
const { Dragger } = Upload;

const TestAttachment = ({
  open,
  handleClose,
}) => {
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    file: null,
  });

  const resetForm = () => {
    setFormData({
      title: "",
      description: "",
      file: null,
    });
  };

  const closeModal = () => {
    if (loading) return;

    resetForm();
    handleClose();
  };

  const handleUpload = async () => {
    if (!formData.title.trim()) {
      Swal.fire(
        "Required",
        "Please enter a title.",
        "warning"
      );
      return;
    }

    if (!formData.file) {
      Swal.fire(
        "Required",
        "Please select a file.",
        "warning"
      );
      return;
    }

    const data = new FormData();

    data.append("title", formData.title);
    data.append(
      "description",
      formData.description
    );
    data.append("file", formData.file);

    try {
      setLoading(true);

      await api.post(
        "/attachments/",
        data,
        {
          headers: {
            "Content-Type":
              "multipart/form-data",
          },
        }
      );

      Swal.fire({
        icon: "success",
        title: "Upload Successful",
        text: "Attachment uploaded successfully.",
        timer: 1800,
        showConfirmButton: false,
      });

      resetForm();
      handleClose();
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text:
          err.response?.data?.detail ||
          "Unable to upload attachment.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={closeModal}
      footer={null}
      centered
      destroyOnClose
      width={650}
      maskClosable={!loading}
    >
      <Flex
        vertical
        align="center"
        gap={4}
      >
        <CloudUploadOutlined
          style={{
            fontSize: 55,
            color: "#1677ff",
          }}
        />

        <Title
          level={3}
          style={{
            marginBottom: 0,
          }}
        >
          Upload Test Attachment
        </Title>

        <Text type="secondary">
          Upload documents, PDFs, images or
          any attachment for testing.
        </Text>
      </Flex>

      <Divider />

      <Form layout="vertical">
        <Form.Item
          label="Title"
          required
        >
          <Input
            size="large"
            placeholder="Enter attachment title"
            value={formData.title}
            onChange={(e) =>
              setFormData({
                ...formData,
                title: e.target.value,
              })
            }
          />
        </Form.Item>

        <Form.Item label="Description">
          <TextArea
            rows={4}
            placeholder="Write a description..."
            value={formData.description}
            onChange={(e) =>
              setFormData({
                ...formData,
                description:
                  e.target.value,
              })
            }
          />
        </Form.Item>

        <Form.Item
          label="Attachment"
          required
        >
          <Dragger
            multiple={false}
            maxCount={1}
            beforeUpload={(file) => {
              setFormData({
                ...formData,
                file,
              });

              return false;
            }}
            onRemove={() => {
              setFormData({
                ...formData,
                file: null,
              });
            }}
            fileList={
              formData.file
                ? [
                    {
                      uid: "-1",
                      name:
                        formData.file.name,
                      status: "done",
                    },
                  ]
                : []
            }
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined
                style={{
                  color: "#1677ff",
                }}
              />
            </p>

            <p
              className="ant-upload-text"
              style={{
                fontWeight: 600,
              }}
            >
              Click or drag a file here
            </p>

            <p
              className="ant-upload-hint"
              style={{
                color: "#777",
              }}
            >
              Supports PDF, Word, Excel,
              Images, ZIP and more.
            </p>
          </Dragger>
        </Form.Item>

        <Space
          style={{
            width: "100%",
            justifyContent: "flex-end",
            display: "flex",
            marginTop: 20,
          }}
        >
          <Button
            size="large"
            onClick={closeModal}
            disabled={loading}
          >
            Cancel
          </Button>

          <Button
            type="primary"
            size="large"
            loading={loading}
            onClick={handleUpload}
          >
            Upload Attachment
          </Button>
        </Space>
      </Form>
    </Modal>
  );
};

export default TestAttachment;